import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from 'src/app/core/services/auth.service';
import { WindowMode } from 'src/app/enums/window-mode.enum';
import { CreditLineFNB } from 'src/app/models/account/credit-line-fnb.model';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-credit-line-fnb',
  templateUrl: './credit-line-fnb.component.html'
})
export class CreditLineFnbComponent implements OnInit, OnDestroy {

  @Input() currentWindowMode: number;
  windowModeList = WindowMode;
  creditLineFNB: CreditLineFNB = new CreditLineFNB();
  accountDataFetchedSubscription: Subscription;
  unsubscribe$ = new Subject();
  
  constructor(private authService: AuthService,
    private commonService: CommonService) { 
    this.accountDataFetchedSubscription = this.commonService.accountDataFetchedAnnounced
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(accountData => {
      this.creditLineFNB = this.authService.getCreditLineFNB();
    });
  }

  ngOnInit() {
    if (this.currentWindowMode == null) { this.currentWindowMode = this.windowModeList.Normal; }
    this.creditLineFNB = this.authService.getCreditLineFNB();
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
